import { render, staticRenderFns } from "./EventCategories.vue?vue&type=template&id=05a59376&scoped=true"
import script from "./EventCategories.vue?vue&type=script&lang=js"
export * from "./EventCategories.vue?vue&type=script&lang=js"
import style0 from "./EventCategories.vue?vue&type=style&index=0&id=05a59376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a59376",
  null
  
)

export default component.exports